module.exports = __webpack_public_path__ + "static/media/group_trainings_dance_mind_body_fitness.4c45e6ea.webp";